import { v4 as uuidv4 } from "uuid";

const API_URL = "https://api.swarmalytics.com/shopifylog";

async function main() {
  const data = {
    id: uuidv4(),
    data: {},
    name: "page_viewed",
    context: {
      window: {
        origin: window.origin,
        screenX: window.screenX,
        screenY: window.screenY,
        scrollX: window.scrollX,
        scrollY: window.scrollY,
        location: window.location,
        innerWidth: window.innerWidth,
        outerWidth: window.outerWidth,
        innerHeight: window.innerHeight,
        outerHeight: window.outerHeight,
        pageXOffset: window.pageXOffset,
        pageYOffset: window.pageYOffset,
      },
      document: {
        title: document.title,
        location: document.location,
        referrer: document.referrer,
        characterSet: document.characterSet,
      },
      navigator: {
        language: navigator.language,
        languages: navigator.languages,
        userAgent: navigator.userAgent,
        cookieEnabled: navigator.cookieEnabled,
      },
    },
    clientId: "",
    timestamp: new Date(Date.now()).toISOString(),
  };

  const response = await fetch(`${API_URL}?id=${document.location.host}`, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    headers: { "Content-Type": "application/json" },
    redirect: "follow",
    body: JSON.stringify(data),
  });
}

main();
